const PRESETS = [
  {
    position: "center",
    0: { x: 0, y: 0, b: 6, s: 12, color: { r: 92, g: 245, b: 158, a: 1 } },
    1: { x: 0, y: 0, b: 0, s: 14, color: { r: 39, g: 160, b: 85, a: 1 } },
  },
  {
    0: { x: 6, y: 6, b: 0, s: 0, color: { r: 0, g: 75, b: 180, a: 1 } },
    1: { x: 12, y: 12, b: 0, s: 0, color: { r: 50, g: 75, b: 200, a: 1 } },
    2: { x: 18, y: 18, b: 0, s: 0, color: { r: 50, g: 100, b: 200, a: 1 } },
    3: { x: 24, y: 24, b: 0, s: 0, color: { r: 125, g: 125, b: 200, a: 1 } },
    4: { x: 30, y: 30, b: 0, s: 0, color: { r: 150, g: 150, b: 200, a: 1 } },
  },
  {
    position: "center",
    0: {
      inset: true,
      x: 0,
      y: 0,
      b: 0,
      s: 4,
      color: { r: 0, g: 0, b: 0, a: 1 },
    },
    1: {
      inset: true,
      x: 0,
      y: 0,
      b: 0,
      s: 8,
      color: { r: 75, g: 75, b: 75, a: 1 },
    },
    2: {
      inset: true,
      x: 0,
      y: 0,
      b: 0,
      s: 12,
      color: { r: 125, g: 125, b: 125, a: 1 },
    },
    3: {
      inset: true,
      x: 0,
      y: 0,
      b: 0,
      s: 16,
      color: { r: 175, g: 175, b: 175, a: 1 },
    },
    4: {
      inset: true,
      x: 0,
      y: 0,
      b: 0,
      s: 20,
      color: { r: 225, g: 225, b: 225, a: 1 },
    },
  },
  {
    position: "center",
    0: { x: 20, y: 0, b: 30, s: 0, color: { r: 218, g: 37, b: 16, a: 1 } },
    1: { x: 0, y: 20, b: 30, s: 0, color: { r: 226, g: 173, b: 29, a: 1 } },
    2: { x: -20, y: 0, b: 30, s: 0, color: { r: 240, g: 232, b: 15, a: 1 } },
    3: { x: 0, y: -20, b: 30, s: 0, color: { r: 243, g: 251, b: 126, a: 1 } },
  },
  {
    position: "center",
    0: { x: 10, y: -10, b: 0, s: 0, color: { r: 100, g: 115, b: 232, a: 1 } },
    1: { x: -10, y: -10, b: 0, s: 0, color: { r: 80, g: 14, b: 123, a: 1 } },
    2: { x: 0, y: 0, b: 0, s: 10, color: { r: 81, g: 178, b: 210, a: 1 } },
  },
  {
    position: "center",
    0: { x: 0, y: 4, b: 0, s: 0, color: { r: 40, g: 113, b: 159, a: 1 } },
    1: { x: 2, y: 2, b: 0, s: 2, color: { r: 86, g: 173, b: 210, a: 1 } },
    2: { x: 4, y: 8, b: 0, s: 0, color: { r: 51, g: 95, b: 122, a: 1 } },
    3: { x: 6, y: 6, b: 0, s: 2, color: { r: 70, g: 147, b: 180, a: 1 } },
    4: { x: 8, y: 12, b: 0, s: 0, color: { r: 24, g: 86, b: 123, a: 1 } },
    5: { x: 10, y: 10, b: 0, s: 2, color: { r: 72, g: 139, b: 168, a: 1 } },
  },
  {
    position: "center",
    0: {
      x: 15,
      y: 0,
      b: 0,
      s: -10,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    1: {
      x: -15,
      y: 0,
      b: 0,
      s: -10,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    2: {
      x: 0,
      y: 15,
      b: 0,
      s: -10,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    3: {
      x: 0,
      y: -15,
      b: 0,
      s: -10,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    4: { x: 0, y: 0, b: 0, s: 4, color: { r: 0, g: 0, b: 0, a: 1 } },
  },
  {
    position: "center",
    0: {
      inset: false,
      x: 15,
      y: 0,
      b: 0,
      s: -10,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    1: {
      inset: false,
      x: -15,
      y: 0,
      b: 0,
      s: -10,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    2: {
      inset: false,
      x: 0,
      y: 15,
      b: 0,
      s: -10,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    3: {
      inset: false,
      x: 0,
      y: -15,
      b: 0,
      s: -10,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    4: {
      inset: false,
      x: 0,
      y: 0,
      b: 0,
      s: 8,
      color: { r: 0, g: 0, b: 0, a: 1 },
    },
    5: {
      inset: true,
      x: 0,
      y: 0,
      b: 0,
      s: 3,
      color: { r: 10, g: 10, b: 10, a: 1 },
    },
  },
  {
    position: "center",
    0: {
      inset: false,
      x: 0,
      y: 0,
      b: 0,
      s: 2,
      color: { r: 18, g: 54, b: 120, a: 1 },
    },
    1: {
      inset: false,
      x: 0,
      y: 0,
      b: 0,
      s: 4,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    2: {
      inset: false,
      x: 0,
      y: 0,
      b: 0,
      s: 6,
      color: { r: 144, g: 157, b: 173, a: 1 },
    },
    3: {
      inset: false,
      x: 0,
      y: 0,
      b: 0,
      s: 8,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    4: {
      inset: false,
      x: 0,
      y: 0,
      b: 0,
      s: 10,
      color: { r: 206, g: 212, b: 228, a: 1 },
    },
  },
  {
    position: "center",
    0: {
      inset: false,
      x: 1,
      y: 1,
      b: 0,
      s: 1,
      color: { r: 50, g: 63, b: 33, a: 1 },
    },
    1: {
      inset: false,
      x: 0,
      y: 0,
      b: 0,
      s: 4,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    2: {
      inset: false,
      x: 3,
      y: 3,
      b: 0,
      s: 3,
      color: { r: 109, g: 149, b: 106, a: 1 },
    },
    3: {
      inset: false,
      x: 2,
      y: 2,
      b: 0,
      s: 6,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    4: {
      inset: false,
      x: 5,
      y: 5,
      b: 0,
      s: 5,
      color: { r: 184, g: 212, b: 160, a: 1 },
    },
  },
  {
    position: "center",
    0: {
      inset: false,
      x: 0,
      y: 3,
      b: 0,
      s: 0,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    1: {
      inset: false,
      x: 3,
      y: 0,
      b: 0,
      s: 0,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    2: {
      inset: false,
      x: 3,
      y: 3,
      b: 0,
      s: 0,
      color: { r: 0, g: 0, b: 0, a: 1 },
    },
    3: {
      inset: false,
      x: 0,
      y: 6,
      b: 0,
      s: 0,
      color: { r: 0, g: 0, b: 0, a: 1 },
    },
    4: {
      inset: false,
      x: 6,
      y: 0,
      b: 0,
      s: 0,
      color: { r: 0, g: 0, b: 0, a: 1 },
    },
    5: {
      inset: false,
      x: 6,
      y: 3,
      b: 0,
      s: 0,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    6: {
      inset: false,
      x: 3,
      y: 6,
      b: 0,
      s: 0,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    7: {
      inset: false,
      x: 6,
      y: 6,
      b: 0,
      s: 0,
      color: { r: 0, g: 0, b: 0, a: 1 },
    },
    8: {
      inset: false,
      x: 3,
      y: 6,
      b: 0,
      s: 3,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    9: {
      inset: false,
      x: 6,
      y: 3,
      b: 0,
      s: 3,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    10: {
      inset: false,
      x: 5,
      y: 5,
      b: 0,
      s: 4,
      color: { r: 0, g: 0, b: 0, a: 1 },
    },
    11: {
      inset: false,
      x: 3,
      y: 9,
      b: 0,
      s: 3,
      color: { r: 0, g: 0, b: 0, a: 1 },
    },
    12: {
      inset: false,
      x: 9,
      y: 3,
      b: 0,
      s: 3,
      color: { r: 0, g: 0, b: 0, a: 1 },
    },
  },

  {
    0: {
      inset: false,
      x: 0,
      y: 0,
      b: 0,
      s: 1,
      color: { r: 0, g: 0, b: 0, a: 1 },
    },
    1: {
      inset: false,
      x: 0,
      y: 5,
      b: 0,
      s: 2,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    2: {
      inset: false,
      x: 5,
      y: 0,
      b: 0,
      s: 2,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    3: {
      inset: false,
      x: 0,
      y: -5,
      b: 0,
      s: 2,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    4: {
      inset: false,
      x: -5,
      y: 0,
      b: 0,
      s: 2,
      color: { r: 255, g: 255, b: 255, a: 1 },
    },
    5: {
      inset: false,
      x: 0,
      y: 0,
      b: 0,
      s: 8,
      color: { r: 0, g: 0, b: 0, a: 1 },
    },
    position: "center",
  },
  {
    0: {
      inset: true,
      x: 0,
      y: 0,
      b: 10,
      s: -1,
      color: { r: 3, g: 3, b: 43, a: 1 },
    },
    1: {
      inset: false,
      x: 0,
      y: 0,
      b: 5,
      s: 2,
      color: { r: 0, g: 0, b: 0, a: 1 },
    },
    position: "center",
  },
  {
    0: {
      inset: false,
      x: 0,
      y: 14,
      b: 0,
      s: -10,
      color: { r: 158, g: 158, b: 158, a: 1 },
    },
    1: {
      inset: false,
      x: 0,
      y: -14,
      b: 0,
      s: -10,
      color: { r: 158, g: 158, b: 158, a: 1 },
    },
    2: {
      inset: false,
      x: 14,
      y: 0,
      b: 0,
      s: -10,
      color: { r: 158, g: 158, b: 158, a: 1 },
    },
    3: {
      inset: false,
      x: -14,
      y: 0,
      b: 0,
      s: -10,
      color: { r: 158, g: 158, b: 158, a: 1 },
    },
    4: {
      inset: false,
      x: 14,
      y: 14,
      b: 0,
      s: -10,
      color: { r: 2, g: 242, b: 238, a: 1 },
    },
    5: {
      inset: false,
      x: -14,
      y: -14,
      b: 0,
      s: -10,
      color: { r: 43, g: 249, b: 16, a: 1 },
    },
    6: {
      inset: false,
      x: 14,
      y: -14,
      b: 0,
      s: -10,
      color: { r: 247, g: 148, b: 94, a: 1 },
    },
    7: {
      inset: false,
      x: -14,
      y: 14,
      b: 0,
      s: -10,
      color: { r: 254, g: 220, b: 1, a: 1 },
    },
    position: "center",
  },
  {
    0: {
      inset: false,
      x: 0,
      y: 0,
      b: 6,
      s: 4,
      color: { r: 31, g: 244, b: 241, a: 1 },
    },
    1: {
      inset: false,
      x: 0,
      y: 0,
      b: 0,
      s: 9,
      color: { r: 70, g: 174, b: 226, a: 1 },
    },
    2: {
      inset: true,
      x: 0,
      y: 0,
      b: 3,
      s: 1,
      color: { r: 0, g: 0, b: 0, a: 1 },
    },
    3: {
      inset: false,
      x: 0,
      y: 0,
      b: 4,
      s: 10,
      color: { r: 0, g: 0, b: 0, a: 1 },
    },
    position: "center",
  },
];

export { PRESETS };
